ResourceDirectory = LP.module 'ResourceDirectory'

ResourceDirectory.index = ->
  LP.module('Searches').initializeTooltip()
  $('a.js-load-list').on 'click', (e)->
    $('.js-active-term').html $(this).text() + ' <i class="fa-solid fa-caret-down"></i>'

ResourceDirectory.show = ->
  LP.module('Searches').initializeTooltip()
